export default __webpack_public_path__ + "static/media/Razorpay_logo.3d34c921.svg";